import { useState, useEffect } from "react";
import { getProfilePictureUrl } from "../utils/imageUtils";

interface ProfileImageProps {
  profilePicture: number | string | null | undefined;
  profilePictureUrl?: string | null;
  accessToken?: string | null;
  alt: string;
  className?: string;
  fallbackPath?: string;
}

export const ProfileImage: React.FC<ProfileImageProps> = ({
  profilePicture,
  profilePictureUrl,
  accessToken,
  alt,
  className = "",
  fallbackPath = "/assets/images/Avatar2.jpg",
}) => {
  const [imageUrl, setImageUrl] = useState<string>(fallbackPath);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const loadImage = async () => {
      setIsLoading(true);
      setHasError(false);
      try {
        const url = await getProfilePictureUrl(
          profilePicture,
          accessToken || undefined,
          fallbackPath,
          profilePictureUrl
        );
        setImageUrl(url);
      } catch (error) {
        console.error("Failed to load profile image:", error);
        setHasError(true);
        setImageUrl(fallbackPath);
      } finally {
        setIsLoading(false);
      }
    };

    loadImage();
  }, [profilePicture, profilePictureUrl, accessToken, fallbackPath]);

  const handleError = () => {
    if (!hasError) {
      setHasError(true);
      setImageUrl(fallbackPath);
    }
  };

  return (
    <img
      src={imageUrl}
      alt={alt}
      className={
        className && /\brounded-/.test(className)
          ? className
          : className
            ? `rounded-md ${className}`.trim()
            : "rounded-md"
      }
      onError={handleError}
      style={{ opacity: isLoading ? 0.5 : 1 }}
    />
  );
};

